import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { addressValidationIssuesApi } from "api/addressValidationIssues";

const ADDRESS_VALIDATION_ISSUES_KEY = "ADDRESS_VALIDATION_ISSUES";

const DEFAULT_PER_PAGE = Number(window.localStorage.getItem("per_page")) || 10;

const REFETCH_INTERVAL_MS = 60_000;

export const useAddressValidationIssues = (page: number) =>
  useQuery({
    queryKey: [ADDRESS_VALIDATION_ISSUES_KEY, page],
    queryFn: () =>
      addressValidationIssuesApi.getIssues({
        page,
        per_page: DEFAULT_PER_PAGE
      }),
    placeholderData: keepPreviousData,
    refetchInterval: REFETCH_INTERVAL_MS
  });
